export const placeholderForFutureLogErrorText: string =
  "Application experienced a fatal error, please contact an MSB admin to resolve.";
